
<h5 class="mb-4">Myrealkorean Support Center</h5>
<div class="form-group">
    <label for="input_type">Support Type</label>
    <select id="input_type" class="form-control"  aria-describedby="typeHelp"[(ngModel)]="_type">
        <option value="select">Select...</option>
        <option value="account">Account</option>
        <option value="purchase">Purchase</option>
        <option value="technical">Technical</option>
        <option value="report">Report</option>
        <option value="etc">Etc</option>
    </select>
    <small id="typeHelp" class="form-text text-muted">Please select a support type that you need.</small>
</div>
<div class="form-group">
    <label for="input_email">Email address</label>
    <input type="email" class="form-control" id="input_email" aria-describedby="emailHelp" placeholder="Enter email..."[(ngModel)]="_email">
    <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>
</div>
<div class="form-group">
    <label for="input_content">Content</label>
    <textarea rows="10" class="form-control" id="input_content" placeholder="Write content..." [(ngModel)]="_content"></textarea>
</div>
<button type="button" class="btn btn-primary" (click)="submitSupport()">Submit</button>